import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {GenericButton} from "../../../../components/buttons/customButtons";

function BenefitItem(props) {
    const {checked, onClick, label, icon, index} = props;
    const [checkedClass, setCheckedClass] = useState('');

    useEffect(() => {
        if (checked === null) {
            setCheckedClass('selectable-benefit-null');
        } else if (checked) {
            setCheckedClass('selectable-benefit-checked');
        } else {
            setCheckedClass('selectable-benefit-unchecked');
        }
    }, [checked]);

    const setIconView = () => {
        let img;
        try {
            img = require("../../../../assets/images/icon/sales/benefit/" + icon + ".png");
        } catch (e) {
            img = require("../../../../assets/images/icon/warning.svg");
        }
       return img;
    }

    // <i class="fa-solid fa-check"></i>
    // <i class="fa-solid fa-plus"></i>
    // <i class="fa-solid fa-xmark"></i>
    return (
        <div className={'selectable-benefit ' + checkedClass} >
            {icon && <img className={'selectable-benefit-icon'} src={setIconView()} alt={""}/>}
            <label>{index + ' - ' + label}</label>
            <GenericButton
                style={checked ? 'danger-secondary' : 'success-secondary' }
                icon={checked ? 'fa-xmark' : 'fa-plus'}
                toolTip={checked ? 'Quitar' : 'Agregar'}
                permission={'edit'}
                onClick={onClick}
            />
        </div>
    );
}

BenefitItem.propTypes = {
    checked: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
};

export default BenefitItem;